import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(" 404 - Siden kunne ikke findes."),
    _hoisted_1,
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _createTextVNode("Gå til forsiden")
      ]),
      _: 1
    })
  ], 64))
}